{
  "title": "Billing",
  "subtitle": "GST tax invoices and value-added-service charges for your 3PL Clients.",
  "tabs": {
    "invoices": "Invoices",
    "vasCharges": "VAS Charges"
  },
  "view": "View",
  "delete": "Delete",
  "finalize": "Finalize",
  "downloadPdf": "PDF",
  "generateInvoice": "Generate Invoice",
  "addVasCharge": "Add VAS Charge",
  "discardChanges": "Discard Changes",
  "table": {
    "invoiceNumber": "Invoice No.",
    "client": "Client",
    "billingPeriod": "Billing Period",
    "gstType": "GST Type",
    "totalAmount": "Total",
    "status": "Status",
    "chargeDate": "Date"
  },
  "form": {
    "client": "Client",
    "periodStart": "Period Start",
    "periodEnd": "Period End",
    "notes": "Notes",
    "chargeCategory": "Category",
    "chargeCode": "Charge Code",
    "chargeDate": "Charge Date",
    "description": "Description",
    "quantity": "Quantity",
    "rate": "Rate",
    "amount": "Amount",
    "gstRatePercent": "GST %"
  },
  "deleteInvoice": {
    "message": "This Draft invoice and its lines will be permanently removed. Any VAS charges it had claimed will return to Unbilled."
  },
  "deleteVasCharge": {
    "message": "This VAS charge will be permanently removed."
  }
}
